module.exports = __webpack_public_path__ + "static/savonne-d9069df51b4788c9e08699618e4e236a.png";